import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Alert } from 'react-bootstrap';
import { Input } from '../common/components/formControls';
import validators from '../common/services/validators';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleRight, faLock } from '@fortawesome/free-solid-svg-icons';

const passwordMinLength = validators.minLength(6);

const ResetPasswordForm = ({ error, handleSubmit, pristine, submitting, t }) => {

	return (
		<form onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			<Field name='password' component={Input} type='password' placeholder={t('ResetPassword_Password')} icon={faLock} validate={[validators.required, passwordMinLength]} />
			<Field name='confirmPassword' component={Input} type='password' placeholder={t('ResetPassword_ConfirmPassword')} icon={faLock} validate={[validators.required, passwordMinLength]} />
			<Field name='token' component={Input} type='hidden' />
			<div className='form-actions'>
				<Button type='submit' disabled={pristine || submitting} className='btn-bricky pull-right'>
					{t('ResetPassword_ResetPassword')} <FontAwesomeIcon icon={faArrowCircleRight} />
				</Button>
			</div>
		</form>
	);
};

ResetPasswordForm.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'resetPassword' })(withTranslation()(ResetPasswordForm));